module.exports = __webpack_public_path__ + "static/how-it-works-2-732b56f98dfcd9d645b66f17e2877c84.svg";